<script setup lang="ts"></script>

<template>
  <div class="form-line-item flex flex-row space-x-2 flex-wrap items-center w-full justify-between">
    <slot name="label" />

    <slot name="input" />
  </div>
</template>

<style scoped></style>
